/* eslint-disable @typescript-eslint/no-unused-vars */
import { Handle, Position } from '@xyflow/react'
import nodeLogo from '@/assets/gifs/hotspot-grey.gif'

function EdgeBoxNodeDT({ data, isConnectable }) {
  return (
    <div className="custom-node-wbg plc-limits">
      <Handle type="target" position={Position.Left} />

      <div className="grid grid-cols-1">
        <div>
          <div className="text-center">
            <img src={nodeLogo} alt="Logo" className="custom-node-plc-logo" />
          </div>
          <div className="text-center">
            <b>Edge Box</b>
          </div>
        </div>
      </div>

      <Handle id="a" type="source" position={Position.Right} />
      <Handle id="b" type="source" position={Position.Bottom} />
    </div>
  )
}

export default EdgeBoxNodeDT
